import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { journalCollection } from "#root/schema/platform/newsrpm-parser";
import PageLayout from "./layout";

export default function BillingCorrespondencesPage(): ReactNode {
  return (
    <PageLayout title="NewsRPM - Manage Journal">
      <PaginatedList title="Latest Journal Entries" collection={journalCollection} refresh={1000}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Created At</th>
              <th>Provider</th>
              <th>Headline</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ createdAt, headline, provider, id }) => (
              <tr key={id}>
                <td style={{ whiteSpace: "nowrap" }}>{new Date(createdAt).toLocaleString()}</td>
                <td>{provider}</td>
                <td>
                  <Link to={`./${id}`}>{headline}</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
